import { ButtonVariants, FormGroup, type ResolutionEnumNoPrefix, ToggleGroup } from '@talos/kyoko';

const OPTIONS = [
  { displayName: '1 Minute', value: '1M' as const },
  { displayName: '1 Hour', value: '1H' as const },
];

/** Toggle between 1 min and 1 hour resolution */
export function SparklineResolutionSetting({
  onChange,
  value,
}: {
  onChange: (resolution: ResolutionEnumNoPrefix) => void;
  value: ResolutionEnumNoPrefix;
}) {
  return (
    <FormGroup
      inline
      justifyContent="space-between"
      data-testid="sparkline-resolution-setting"
      label="Sparkline Resolution"
    >
      <ToggleGroup
        value={value}
        onChange={onChange}
        options={OPTIONS}
        defaultSelectedVariant={ButtonVariants.Priority}
      />
    </FormGroup>
  );
}
